import { colors } from '../../Colors/colors'

export const boardsTheme = {
   light: {
      createBoard: {
         boardHeading: 'text-gray-900',
         description: 'text-gray-600',
         arrowNarrowIconColor: colors['base-white'],
         closeIconColor: colors['gray-500']
      },
      deleteBoard: {
         backgroundColor: 'bg-base-white',
         boardHeading: 'text-gray-900',
         description: 'text-gray-600',
         closeIconColor: colors['gray-500']
      },
      cardTextColor: 'text-gray-600',
      cardHeaderTextColor: 'text-gray-700',
      cardBorderColor: 'border-gray-300',
      iconColors: {
         editIcon: {
            editIconColor: colors['gray-800'],
            editIconBgColor: 'bg-base-white',
            editIconHoverColor: 'hover:bg-gray-100',
            editBorderColor: 'border-gray-300'
         },
         trashIcon: {
            trashColor: colors['error-600'],
            trashIconBgColor: 'bg-base-white',
            trashIconHoverColor: 'hover:bg-gray-100',
            trashBorderColor: 'border-gray-300'
         }
      },
      conditions: {
         andCondition: {
            bgColor: 'bg-primary-50',
            textColor: 'text-primary-700'
         },
         orCondition: {
            bgColor: 'bg-purple-50',
            textColor: 'text-purple-700'
         }
      },
      boardHeader: {
         boardHeader: 'bg-base-white border-gray-200',
         boardNameColor: 'text-gray-900',
         buttonContainerColor: 'text-gray-600',
         disabledIconColor: colors['gray-300'],
         enabledIconColor: colors['gray-600'],
         activeSidePaneBgColor: 'bg-gray-50',
         filtersAppliedIconColor: colors['primary-600'],
         plusIconColor: colors['gray-700'],
         infoIconColor: colors['gray-500']
      },
      userSearchController: {
         customOption: {
            customOptionLabelColor: 'text-gray-900',
            checkIconColor: colors['primary-600'],
            disabledCustomOptionBgColor: 'bg-gray-25',
            disabledCustomOptionTextColor: 'text-gray-300',
            customOptionFocusBgColor: 'bg-gray-50',
            customOptionHoverBgColor: 'hover:bg-gray-50'
         },
         customBadge: {
            badgeBorderColor: 'border-gray-300',
            badgeCloseIconColor: colors['gray-400'],
            customBadgeTextColor: 'text-gray-700'
         }
      },
      shareController: {
         shareBoardHeadingColor: 'text-gray-800',
         shareDescriptionColor: 'text-gray-600',
         shareBadgeBorderColor: 'border-gray-300',
         shareBadgeTextColor: 'text-gray-700',
         backButtonTextColor: 'text-primary-600',
         shareHorizontalColor: 'bg-gray-300',
         footerTopBorder: 'border-gray-300',
         closeIconColor: colors['gray-400'],
         dividerColor: 'border-gray-300',
         groupIconColor: colors['primary-600'],
         groupNameColor: 'text-gray-700',
         hrLineColor: 'bg-gray-300',
         trashIconColor: colors['error-700'],
         customOption: {
            customOptionLabelColor: 'text-gray-900',
            checkIconColor: colors['primary-600'],
            disabledCustomOptionBgColor: 'bg-gray-25',
            disabledCustomOptionTextColor: 'text-gray-300',
            customOptionFocusBgColor: 'bg-gray-50',
            customOptionHoverBgColor: 'hover:bg-gray-50'
         },
         skeletonLoader: {
            skeletonBgColor: '#EAECF0', //FIXME: update hex codes
            skeletonColor: '#F6F7F9'
         },
         noDataViewSharedUsers: {
            titleColor: 'text-gray-700'
         },
         noDataViewSharedUserGroups: {
            titleColor: 'text-gray-700'
         },
         shareTabs: {
            tabIconSelectedColor: colors['primary-600'],
            tabIconColor: colors['gray-400'],
            tabBorderColor: 'border-gray-300'
         },
         ownerContainerBorderColor: 'border-gray-300',
         ownerTextColor: 'text-gray-700'
      },
      pinnedBoard: {
         pinnedByUserLabelTextColor: 'text-gray-800',
         dividerColor: 'bg-gray-300'
      },
      adminBoard: {
         plusIconColor: colors['base-white'],
         headerBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         boardBodyBgColor: 'bg-gray-100',
         boardHeaderBgColor: 'bg-base-white',
         boardBgColor: 'bg-base-white'
      },
      boardActions: {
         hoverBgColor: 'hover:bg-gray-200',
         menuOpenedStateBgColor: 'bg-gray-200',
         borderColor: 'border-gray-200',
         bgColor: 'bg-gray-50',
         selectedBgColor: 'bg-primary-50'
      },
      option: {
         optionTextColor: 'text-gray-700',
         hoverBgColor: 'hover:bg-gray-50',
         borderColor: 'border-gray-200',
         dividerColor: 'bg-gray-300',
         deleteActionTextColor: 'text-error-600'
      },
      exportViewPipelineItemsModal: {
         titleColor: 'text-gray-900',
         noteTextColor: 'text-gray-700',
         confirmationTitleColor: 'text-gray-900',
         confirmationNoteTextColor: 'text-gray-600'
      },
      boardInfoCard: {
         titleColor: 'text-gray-900',
         boardBgColor: 'bg-base-white',
         activeBoardBgColor: 'bg-gray-50',
         boardHoverBgColor: 'hover:bg-gray-50',
         boardTitleColor: 'text-gray-900',
         boardDescriptionColor: 'text-gray-800',
         chevronIconColor: colors['gray-500']
      },
      createApplication: {
         noteColor: 'text-gray-900',

         tdrCertificateNumberInput: {
            titleColor: 'text-gray-700'
         }
      }
   },
   dark: {}
}
